import { Fragment } from 'react';
import LocalitiesItems from './localities-item/localities-item';
import LocalitiesListHead from './localities-head';
import { MaxNumberItemsContextProvieder } from './context/max-number-items-context';
import { NumberItemsContextProvieder } from './context/number-items-context';
import styles from 'styles/LandingLocalitiesList.module.scss';
import ViewMoreButton from './view-more-button';

const LocalitiesList = () => {
    const INITIAL_NUMBER_ITEMS = 15;

    return (
        <Fragment>
            <MaxNumberItemsContextProvieder>
                <NumberItemsContextProvieder initialNumberItems={INITIAL_NUMBER_ITEMS}>
                    <div className={styles.cities_wrapper}>
                        <LocalitiesListHead />
                        <LocalitiesItems />
                        <ViewMoreButton
                            showAll
                            initialNumberItems={INITIAL_NUMBER_ITEMS}
                        />
                    </div>
                </NumberItemsContextProvieder>
            </MaxNumberItemsContextProvieder>
        </Fragment>
    );
};

export default LocalitiesList;
